import * as React from 'react';

const DOTS = '...';
const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
};
const usePagination = (totalPageCount, currentPage, isMobile) => {
    const paginationRange = React.useMemo(() => {
        const firstPageIndex = 1;
        const lastPageIndex = totalPageCount;
        const totalPageNumbers = isMobile ? 5 : 7;
        if (totalPageCount === 1) {
            return [];
        }
        if (isMobile) {
            if (totalPageNumbers >= totalPageCount) {
                return range(1, totalPageCount);
            }
            if (currentPage < 1) {
                return [...range(firstPageIndex, 3), DOTS, lastPageIndex];
            }
            if (currentPage === 1) {
                return [...range(1, 4), DOTS, lastPageIndex];
            }
            if (currentPage === 8) {
                return [firstPageIndex, DOTS, ...range(lastPageIndex - 3, lastPageIndex)];
            }
            if (currentPage > lastPageIndex - 3) {
                return [firstPageIndex, DOTS, ...range(lastPageIndex - 2, lastPageIndex)];
            }
            return [firstPageIndex, DOTS, ...range(currentPage, currentPage + 2), `${DOTS}_2`, lastPageIndex];
        }
        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        if (currentPage < 3) {
            return [...range(firstPageIndex, 5), DOTS, lastPageIndex];
        }
        if (currentPage === 3) {
            return [...range(1, 6), DOTS, lastPageIndex];
        }
        if (currentPage === lastPageIndex - 4) {
            return [firstPageIndex, DOTS, ...range(lastPageIndex - 5, lastPageIndex)];
        }
        if (currentPage > lastPageIndex - 5) {
            return [firstPageIndex, DOTS, ...range(lastPageIndex - 4, lastPageIndex)];
        }
        return [firstPageIndex, DOTS, ...range(currentPage - 1, currentPage + 3), `${DOTS}_2`, lastPageIndex];
    }, [isMobile, totalPageCount, currentPage]);
    return paginationRange;
};

export { usePagination };
//# sourceMappingURL=usePagination.js.map
